export default "__VITE_ASSET__9e878881__"